// extracted by mini-css-extract-plugin
export var attachment = "_nw-a";
export var emailContainer = "_nw-4";
export var emailContentPaddedContainer = "_nw-b";
export var emailHeader = "_nw-6";
export var emailIframe = "_nw-3";
export var emailInfoIcon = "_nw-9";
export var emailShortenedSummary = "_nw-e";
export var infoDropdown = "_nw-0";
export var infoRowBoundedContent = "_nw-d";
export var internal = "_nw-5";
export var merchant = "_nw-8";
export var messageInputContainer = "_nw-h";
export var normal = "_nw-7";
export var replyCard = "_nw-f";
export var subtleButton = "_nw-1";
export var subtleButtonIconContainer = "_nw-2";
export var toggleViewRepliesButton = "_nw-c";
export var wrappingText = "_nw-g";